import { render, staticRenderFns } from "./original_video.vue?vue&type=template&id=12c5062e&"
import script from "./original_video.vue?vue&type=script&lang=js&"
export * from "./original_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports